'use client';

import { usePathname } from 'next/navigation';

import type { BuyItAgainGuestPlacement } from '@libs/common-types';

import { type OptexBiaGuestProduct, useOptexBiaGuest } from '../../../../hooks';

const OPTEX_SEARCH_BIA_GUEST_CALLER = 'web:searchbar:bia-guest';

export type OptexSearchBiaGuestProduct = Omit<OptexBiaGuestProduct, 'hit'>;

export function getOptexSearchBiaGuestPlacement(pathname: string): BuyItAgainGuestPlacement {
    return /(?:^|\/)cart\/?$/.test(pathname) ? 'incart' : 'homepage';
}

export function useOptexSearchBiaGuest(isOptexSearchBiaGuestEnabled: boolean) {
    const optexPathname = usePathname() ?? '';
    const optexPlacement = getOptexSearchBiaGuestPlacement(optexPathname);

    return useOptexBiaGuest({
        optexEnabled: isOptexSearchBiaGuestEnabled,
        optexPlacement,
        optexCaller: OPTEX_SEARCH_BIA_GUEST_CALLER,
    });
}
